// =============================================================================
// PORTAL NEW PASSWORD PAGE (PortalNewPasswordPage.js)
// =============================================================================
// Forces users to set a permanent password after temp password login.
// Adapted from cdic-portal-react/client/src/pages/NewPasswordPage.js
// =============================================================================

import React, { useState } from 'react';
import { setNewPassword } from './portalApi';
import PortalLayout from './PortalLayout';
import PortalFlashMessage from './PortalFlashMessage';

function PortalNewPasswordPage({ onNavigate }) {
  const [newPassword, setNewPasswordValue] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('info');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const data = await setNewPassword(newPassword);
      if (data.success) {
        setMessage(data.message);
        setMessageType('success');
        setTimeout(() => {
          onNavigate('login');
        }, 2000);
      } else {
        setMessage(data.message || 'Error changing password.');
        setMessageType('error');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
      setMessageType('error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PortalLayout showLogout={false} onNavigate={onNavigate}>
      <div className="cdic-portal-form-box">
        <h2>Set New Password</h2>
        <p style={{ color: '#666', marginBottom: '20px', fontSize: '14px', lineHeight: 1.5 }}>
          Please set a new permanent password for your account.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="cdic-portal-input-container">
            <i className="material-icons">lock</i>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPasswordValue(e.target.value)}
              required
            />
          </div>

          <div className="cdic-portal-password-requirements">
            Password requirements:
            <ul>
              <li>At least 8 characters</li>
              <li>Include uppercase and lowercase letters</li>
              <li>Include at least one number</li>
              <li>Include at least one special character</li>
            </ul>
          </div>

          <button type="submit" disabled={isLoading}>
            {isLoading ? 'SETTING...' : 'SET PASSWORD'}
            {!isLoading && <i className="material-icons" style={{ marginLeft: '5px' }}>vpn_key</i>}
          </button>
        </form>

        <PortalFlashMessage
          message={message}
          type={messageType}
          onClose={() => setMessage('')}
        />
      </div>
    </PortalLayout>
  );
}

export default PortalNewPasswordPage;
